export default __webpack_public_path__ + "static/media/view_grid.1afda891.svg";